export default __webpack_public_path__ + "static/media/ss2016-04-28at11_40_10.faca3805.jpg";